export default __webpack_public_path__ + "static/media/IconDesc_PckagedSulphuricAcid.256.4514dd1d.png";